import request from "@/api/http/request";
import {
  POST_QUERY_PAPERS,
  POST_QUERY_BY_ID_COURSE_PAPERS,
  POST_QUERY_CHAPTER_PAPERS,
  POST_PAPERS_SUBMIT,
  POST_QUERY_BYID_PAPERS,
  POST_QUERY_COURSE_PAPERS,
  POST_EXAM_MY_PAPERS,
  POST_EXAM_QUERY_STUDENT_PAPERS,
  POST_QUERY_GENERAL_PAPERS,
} from "@/api/apiConst/exam";
import type { courseItemTypes } from "./courseCenter";

export interface paperDefaultType {
  businessId: string;
  introduction: string;
  score: number;
  title: string;
  version: number;
  examEndTime?: string;
  /** 是否可以考试 */
  examFlag?: boolean;
  /** 是否通过考试 */
  examPassFlag?: boolean;
  examStartTime?: string;
  examSurplusNum?: number;
  subjects: subjectItemType[];
}
export interface subjectItemType {
  businessId: string;
  pictures?: string;
  examId: string;
  labelId: string;
  labelName: string;
  answer?: string[];
  options: optionItemtype[] | string;
  score: number;
  sort: number;
  subject: string;
  type: "1" | "2" | "3";
}
export interface optionItemtype {
  analysis: string;
  answer: string;
  index: number;
}
// 能力诊断试卷详情
export function postQueryPapers() {
  return request.post<paperDefaultType>(POST_QUERY_PAPERS);
}
// 完课试卷详情
export function postQueryCoursePapers(data: { id: string }) {
  return request.post<paperDefaultType>(POST_QUERY_BY_ID_COURSE_PAPERS, data);
}
// 章节试卷详情
export function postQueryChapterPapers(data: { id: string }) {
  return request.post<paperDefaultType>(POST_QUERY_CHAPTER_PAPERS, data);
}
// 试卷详情
export function postQueryGeneralPapers(data: { id: string; type: "4" | "5" }) {
  return request.post<paperDefaultType>(POST_QUERY_GENERAL_PAPERS, data);
}

export interface papersSubmitType {
  courseId?: string;
  answerTime: string;
  /** 1手动提交 2自动提交 */
  submitType: 1 | 2;
  dtoList: {
    businessId: string;
    studentAnswer: string[];
  }[];
  examId: string;
  version: number;
  scoreReviewId?: string;
}
// 试卷提交
export function postPapersSubmit(data: papersSubmitType) {
  return request.post<{
    examId: string;
    examScores: number;
    time: string;
    examEndTime?: string;
    /** 是否可以继续考试 */
    examFlag?: boolean;
    /** 考试是否通过 */
    examPassFlag?: boolean;
    examStartTime?: string;
    /** 剩余考试次数 */
    examSurplusNum?: number;
    showAnswer: 0 | 1;
  }>(POST_PAPERS_SUBMIT, data, {
    headers: {
      "Content-Type": "application/json;charset=UTF-8",
    },
  });
}

/** 学员考试详情类型 */

export interface examPaperStudentDefaultType {
  /** 考试时间 */
  answerTime: string;
  /** 题目维度列表 */
  examLabelVOList?: examLabelVOListType[];
  /** 试卷标题 */
  examPapersTitle: string;
  /** 试卷维度 雷达图数据 */
  examStudentRadarVOList?: examStudentRadarVOListType[];
  papersTimes: string;
  /** 试卷总分 */
  score: 10;
  /** 学员名称 */
  studentName: string;
  /** 非维度标签下的题目列表 */
  studentSubjects?: examStudentSubjectType[];
  /** 学员类型 */
  studentType: string;
  /** 学员类型 */
  studentTypeRef: string;
  /** 答题时长 */
  time: string;
  /** 学员uid */
  uid: string;
  showAnswer: 0 | 1
}
/** 试卷维度列表 */
export interface examStudentRadarVOListType {
  /** 维度名称 */
  label: string;
  /** 维度总分 */
  score: number;
}
/** 题目维度列表类型 */
export interface examLabelVOListType {
  /** 维度标题 */
  label: string;
  /** 维度id */
  labelId: string;
  /** 维度总分 */
  score: number;
  /** 排序 */
  sort: number;
  /** 学员维度总分 */
  studentScore: number;
  /** 维度题目列表 */
  subjects: examStudentSubjectType[];
}
/** 题目列表类型 */
export interface examStudentSubjectType {
  /** 题目解析 */
  analysis: string;
  /** 题目答案 */
  answer: string;
  /** 考试id */
  examId: string;
  /** 维度id */
  labelId: string;
  /** 维度标题 */
  labelName: string;
  pictures?: string;
  /** 题目选项 */
  options: string | subjectOptionType[];
  /** 学员答题是否答对 */
  resultFlag: number;
  /** 题目分数 */
  score: number;
  sort: number;
  /** 学员答案 */
  studentAnswer: (string | number)[];
  /** 学员得分 */
  studentScore: number;
  /** 题目类型ref */
  subject: string;
  /** 题目类型 */
  type: string;
  /** 题目版本 */
  version: number;
}
export interface subjectOptionType {
  /** 选项解析 */
  analysis?: string;
  /** 选项内容 */
  answer: string;
  index: number;
}
// 查询试卷答题记录详情
export function postPapersQueryById(data: { id: string }) {
  return request.post<examPaperStudentDefaultType>(
    POST_QUERY_BYID_PAPERS,
    data
  );
}
// 能力诊断成绩详情
export function postExamMyPapers(data?: { businessId: string }) {
  return request.post<examPaperStudentDefaultType | null>(
    POST_EXAM_MY_PAPERS,
    data
  );
}

// 维度推荐课查询
export function postPapersQueryCourse(data: {
  labelId: string;
  limit: number;
  page: number;
}) {
  return request.post<{ records: courseItemTypes[]; total: number }>(
    POST_QUERY_COURSE_PAPERS,
    data
  );
}

export interface logsType {
  /** 开始答题时间 */
  answerTime: string;
  businessId: string;
  /** 答题提交时间 */
  createDate: string;
  /** 试卷标题 */
  examPapersTitle: string;
  id: string;
  /** 考试允许时长 */
  papersTimes: string;
  /** 试卷介绍 */
  remarks: string;
  /** 考试分数 */
  score: number;
  /** 学员Id */
  studentId: string;
  /** 学员名称 */
  studentName: string;
  /** 学员类型 */
  studentType: string;
  /** 答题时长 */
  time: string;
  uid: string;
}
// 答题记录列表
export function postPapersQueryLogs(data: { limit: number; page: number }) {
  return request.post<{ records: logsType[]; total: number }>(
    POST_EXAM_QUERY_STUDENT_PAPERS,
    data
  );
}